import { TransformsList } from 'cio/utils/analytics/transforms';
import { ImportValidateMeta } from 'cio/utils/imports';

const MAX_EVENT_PROPERTY_LENGTH = 149;

const Transforms: TransformsList = {
  base(data) {
    return { Source: data.source };
  },

  routeView(data) {
    return {
      'Import ID': data.model!.id ?? undefined,
      'Import Type': data.model?.type,
    };
  },

  reviewRouteView(data) {
    let {
      id,
      type,
      validateMeta: {
        newProfiles,
        existingProfiles,
        emailChanges,
        warningRows,
        invalidRows,
        warnings,
        errors,
        eventCardinality,
        rows,
      },
    } = data.model!;

    return {
      'Import ID': id,
      'Imported New People': newProfiles,
      'Updated Existing People': existingProfiles,
      'Email Changes': emailChanges,
      Warnings: warningRows,
      Errors: invalidRows,
      'Warning Content': warnings?.map((warning: string) => warning.slice(0, MAX_EVENT_PROPERTY_LENGTH)),
      'Error Content': errors?.map((error: string) => error.slice(0, MAX_EVENT_PROPERTY_LENGTH)),
      'Event Cardinality': eventCardinality,
      'Import Type': type,
      'Total Events': rows,
    };
  },

  upload(data) {
    return {
      'Upload Type': (
        {
          from_disk: 'File',
          from_google_sheet: 'Google Sheet',
        } as any
      )[data.source],
      'Dragged and Dropped': data.dragAndDrop ?? false,
    };
  },

  fileExport(data) {
    return {
      'Import ID': data.model!.id,
    };
  },

  preview(data) {
    let meta = data.model!.validateMeta as ImportValidateMeta;

    return {
      'Import ID': data.model!.id,
      'Imported New People': meta.newProfiles,
      'Updated Existing People': meta.existingProfiles,
      'Email Changes': meta.emailChanges,
      Warnings: meta.warningRows,
      Errors: meta.invalidRows,
      'Event Cardinality': meta.eventCardinality,
      'Import Type': data.model?.type,
      'Total Events': meta.rows,
    };
  },

  attributeMapped(data) {
    return {
      'Import ID': data.model!.id,
      'Import Type': data.model?.type,
      Attribute: data.attribute,
      'Mapping Change Type': 'Mapping Changed',
    };
  },

  attributeSkipped(data) {
    return {
      'Import ID': data.model!.id,
      'Import Type': data.model?.type,
      Attribute: data.attribute,
      'Mapping Change Type': 'Mapping Skipped',
    };
  },

  canceled(data) {
    return {
      'Import ID': data.model!.id ?? undefined,
      'Import Type': data.model?.type,
      Source: (
        {
          'imports.new': 'Upload CSV Tab',
          'imports.import.setup.index': 'Upload CSV Tab',
          'imports.import.setup.fields': 'Map Fields Tab',
          'imports.import.setup.review': 'Review Tab',
        } as Record<string, string>
      )[data.source],
    };
  },

  uploadChanged(data) {
    return {
      'Import ID': data.model!.id ?? undefined,
      'Import Type': data.model?.type,
      'Upload Type': data.model!.sheet ? 'Google Sheet' : 'File',
    };
  },

  fieldWarningDisplayed(data) {
    return {
      'Import ID': data.model!.id,
      'Import Type': data.model?.type,
      'Upload Type': data.model!.sheet ? 'Google Sheet' : 'File',
      Warning: data.warning.slice(0, MAX_EVENT_PROPERTY_LENGTH),
      'Fields Available': data.model!.preprocessMeta.attributes,
    };
  },

  eventColumnWarning(data) {
    return {
      'Import ID': data.model!.id,
      'Import Type': data.model?.type,
      Column: data.column,
    };
  },

  identifierFeedbackCompleted(data) {
    return {
      'What value other than ID or email would you like to use to identify people?': data.feedback,
    };
  },
};

export default Transforms;
